import { IStepCard } from '@vfit/shared/models';
import { IFlow, IOtpFLow, IPersonalInfoFlow } from './checkoutEnergy.models';
import NameFiscalCodeCard from './components/NameFiscalCodeCard/nameFiscalCodeCard';
import OtpCard from './components/OtpCard/otpCard';
import ConfirmIdentityCard from './components/ConfirmIdentityCard/confirmIdentityCard';
import { ID_FLOWS } from './checkoutEnergy.constants';

export const COMPONENTS_FLOW = [
  {
    title: ID_FLOWS.PERSONAL_INFO,
    component: NameFiscalCodeCard,
  },
  {
    title: ID_FLOWS.CONFIRM_IDENDITY,
    component: ConfirmIdentityCard,
  },
  {
    title: ID_FLOWS.OTP,
    component: OtpCard,
  },
];

export const getFlowComponentByTitle = (title: string): IStepCard => {
  return COMPONENTS_FLOW.find((el: { title: string }) => el.title === title) || {};
};

const OTP_FLOW: IOtpFLow = {
  OTP: [getFlowComponentByTitle(ID_FLOWS.CONFIRM_IDENDITY), getFlowComponentByTitle(ID_FLOWS.OTP)],
};

const PERSONAL_INFO_FLOW: IPersonalInfoFlow = {
  PERSONAL_INFO: [getFlowComponentByTitle(ID_FLOWS.PERSONAL_INFO)],
};

export const EMPTY_FLOWS = {
  EMPTY: [
    {
      title: '',
      component: undefined,
    },
    {
      title: '',
      component: undefined,
    },
  ],
};

const ENERGY_FLOW: IFlow = {
  DEFAULT: [...PERSONAL_INFO_FLOW.PERSONAL_INFO, ...EMPTY_FLOWS.EMPTY],
};

export { ENERGY_FLOW, PERSONAL_INFO_FLOW, OTP_FLOW };
